import {useEffect} from "react";
import {Control, Controller} from "react-hook-form";
import {Dropdown} from "primereact/dropdown";
import {classNames} from "primereact/utils";
import "./DropdownInputWithIcon.scss";

export interface DropdownInputWithIconProps {
    id: string;
    value: string | number | boolean;
    optionValue?: string
    optionLabel?: string
    onValueChange: (property: string, value: string) => void;
    options: any;
    icon?: string;
    filter?: boolean;
    labelText: string;
    placeholderText: string;
    control: Control;
    setValue?: any;
    errors: any;
    rules?: any;
    disabled?: boolean;
};

export const DropdownInputWithIcon = (p: DropdownInputWithIconProps) => {
    const {
        id,
        value,
        optionValue,
        optionLabel,
        onValueChange,
        options,
        icon,
        filter,
        labelText,
        placeholderText,
        control,
        setValue,
        errors,
        rules,
        disabled
    } = p;

    useEffect(() => {
        if (setValue) setValue(labelText, value)
    }, [value]);

    return (
        <div className="dropdown-input-with-icon">
            <label
                className={classNames("dropdown-input-with-icon-label", {
                    'p-error': errors[labelText],
                })}
                htmlFor={id}
            >
                {labelText}
            </label>
            <span className="dropdown-icon-wrapper">
                <i className={icon + " dropdown-icon"} />
            </span>
            <Controller
                name={labelText}
                control={control}
                rules={rules}
                render={({ field, fieldState }) => (
                    <Dropdown
                        {...field}
                        id={id}
                        placeholder={placeholderText}
                        value={value}
                        onChange={(e)=>{
                            field.onChange(e);
                            onValueChange(id, e.target.value)}}
                        options={options}
                        filter={filter}
                        optionValue={optionValue}
                        optionLabel={optionLabel}
                        disabled={disabled}
                        className={classNames('dropdown-with-icon', 'dropdown-input-field', { 'p-invalid': fieldState.invalid })}
                        />
                    )}
            />
        </div>
    );
};
